import {
    buildConfigSlice,
    useConfigSlice,
    WidgetConfigSliceActionPayloadType,
} from 'widgets/store/configuration/configSlice';
import { WidgetType } from 'widgets/WidgetType';
import {
    initialObvTileConfigState,
    ObvTileConfigState,
} from './ObvTileConfigState';
import { selectObvTileState } from '../selectors';

export const buildObvTileConfigSlice = () =>
    buildConfigSlice<ObvTileConfigState>(
        WidgetType.OBV_TILE,
        selectObvTileState,
        initialObvTileConfigState
    );

export const useObvTileConfigSlice = () =>
    useConfigSlice(buildObvTileConfigSlice());

export type ObvTileConfigPayloadType =
    WidgetConfigSliceActionPayloadType<ObvTileConfigState>;
